import React, { useState } from 'react';

const Button = ({
  onClick,
  icon: Icon,
  label,
  videoDevices,
  audioDevices,
  onSelectOption,
  type,
}) => {
  const resolutionInput = [
    {
      id: 0,
      resolution: '320x240 (QVGA)',
      value: 'QVGA',
    },
    {
      id: 1,
      resolution: '640x480 (VGA)',
      value: 'VGA',
    },
    {
      id: 2,
      resolution: '720x480 (SD)',
      value: 'SD',
    },
    {
      id: 3,
      resolution: '1280x720 (HD)',
      value: 'HD',
    },
    {
      id: 4,
      resolution: '1920x1080 (FHD)',
      value: 'FHD',
    },
    {
      id: 5,
      resolution: '2560x1440 (2K)',
      value: '2K',
    },
    {
      id: 6,
      resolution: '3840x2160 (4K)',
      value: '4K',
    },
  ];
  const [selectedOption, setSelectedOption] = useState('');
  const handleOptionChange = (event) => {
    const selectedValue = event.target.value;
    const selectedIndex = event.target.selectedIndex;
    setSelectedOption(selectedValue);
    let deviceId;
    if (type === 'video') {
      const deviceInfo = videoDevices.find((video, index) => index === selectedIndex);
      deviceId = deviceInfo.deviceId;
    }
    if (type === 'mic') {
      const deviceInfo = audioDevices.find((audio, index) => index === selectedIndex);
      deviceId = deviceInfo.deviceId;
    }
    if (type === 'resolution') {
      const deviceInfo = resolutionInput.find((resolution, index) => index === selectedIndex);
      deviceId = deviceInfo.value;
    }
    onSelectOption(deviceId);
  };
  return (
    <>
      <div className="flex flex-col w-fit items-center group peer relative">
        <button
          type="button"
          className="xs:w-10 xs:h-10 sm:w-12 sm:h-12 bg-charcoal-trans rounded-xl "
          onClick={onClick}
        >
          {Icon && <Icon className="text-white xs:w-5 xs:h-5 sm:w-6 sm:h-6 ml-auto mr-auto" />}
        </button>
        <span className="text-white text-sm mt-2">{label}</span>
        {type === 'video' && videoDevices && (
          <select
            onChange={handleOptionChange}
            value={selectedOption}
            className="invisible bg-white mt-5 rounded-md  text-black group-hover:visible w-30 h-10 absolute top-[58%] right-[-220px] z-30"
          >
            {videoDevices.map((video, item) => (
              <option key={item}>{video.label}</option>
            ))}
          </select>
        )}
        {type === 'mic' && audioDevices && (
          <select
            onChange={handleOptionChange}
            value={selectedOption}
            className="invisible bg-white mt-5 rounded-md  text-black  group-hover:visible w-30 h-10 absolute top-[58%] right-[-220px] z-30"
          >
            {audioDevices.map((audio, item) => (
              <option key={item}>{audio.label}</option>
            ))}
          </select>
        )}
        {type === 'resolution' && resolutionInput && (
          <select
            onChange={handleOptionChange}
            value={selectedOption}
            className="invisible bg-white mt-5 rounded-md  text-black group-hover:visible w-30 h-10 absolute top-[58%]  z-30"
          >
            {resolutionInput.map((resolution, item) => (
              <option key={item}>{resolution.value}</option>
            ))}
          </select>
        )}
      </div>
    </>
  );
};

export default Button;
